export default "__VITE_ASSET__BGsWKujR__"